import TariffChangeService from '@/services/TariffChangeService';
import { toggleInstance } from '@/services/xml-rpc/ToggleModulesService';
import { enableIVRInstance } from '@/services/xml-rpc/HotlineService';
import { SetTarif } from '../../models/Tariff';
import router from '@/router';
import {logout} from '@/services/Authentication';

export default {
    state: {
        isPremium: false,
        isTest: false
    },

    getters: {
        isPremium(state: any) {
            return state.isPremium;
        },
        isTest(state: any) {
            return state.isTest;
        }
    },

    actions: {
        getTarif(context: any, payload: string) {
            return TariffChangeService.getTariff(payload).then( response => {
                if (response.data.success) {
                    if (response.data.success.tariff === 'tester') {
                        context.commit('CHANGE_CURRENT_TARIFF', true);
                        context.commit('CHANGE_TEST_TARIFF', true);
                        enableIVRInstance(true);
                        return true;
                    }
                    if (response.data.success.tariff === 'free') {
                        context.commit('CHANGE_CURRENT_TARIFF', false);
                        context.commit('CHANGE_TEST_TARIFF', false);
                        toggleInstance(false);
                        return false;
                    }
                    if (response.data.success.tariff === 'complete') {
                        context.commit('CHANGE_CURRENT_TARIFF', true);
                        context.commit('CHANGE_TEST_TARIFF', false);
                        enableIVRInstance(true);
                        return true;
                    }
                }
                if (response.data.error) {
                    logout();
                    router.replace('login');
                }
            });
        },
        setTarif(context: any, payload: SetTarif) {
            return TariffChangeService.setTariff(payload).then( response => {
                if (response.data.success) {
                    if (response.data.success.tariff === 'tester') {
                        context.commit('CHANGE_CURRENT_TARIFF', true);
                        context.commit('CHANGE_TEST_TARIFF', true);
                        enableIVRInstance(true);
                    }
                    if (response.data.success.tariff === 'free') {
                        context.commit('CHANGE_CURRENT_TARIFF', false);
                        context.commit('CHANGE_TEST_TARIFF', false);
                        toggleInstance(false);
                    }
                    if (response.data.success.tariff === 'complete') {
                        context.commit('CHANGE_CURRENT_TARIFF', true);
                        context.commit('CHANGE_TEST_TARIFF', false);
                        enableIVRInstance(true);
                        return true;
                    }
                }
                if (response.data.error) {
                    logout();
                    router.replace('login');
                }
            });
        }
    },

    mutations: {
        CHANGE_CURRENT_TARIFF(state: any, tariff: boolean) {
            state.isPremium = tariff;
        },
        CHANGE_TEST_TARIFF(state: any, tariff: boolean) {
            state.isTest = tariff;
        }
    }

};
